import {
  AnimationAnimateMetadata,
  AnimationStyleMetadata,
  animate,
  style,
} from '@angular/animations';

export const collapseAnimation: (
  currentHeight: number
) => (AnimationStyleMetadata | AnimationAnimateMetadata)[] = (
  currentHeight: number
) => {
  return [
    style({
      height: currentHeight,
    }),
    animate(
      '0.4s',
      style({
        height: 0,
      })
    ),
  ];
};

export const expandAnimation: (
  currentHeight: number
) => (AnimationStyleMetadata | AnimationAnimateMetadata)[] = (
  currentHeight: number
) => {
  return [
    style({
      height: 0,
    }),
    animate(
      '0.4s',
      style({
        height: currentHeight,
      })
    ),
  ];
};
